import styled from 'styled-components'
import Card from 'react-bootstrap/Card'

export const SubjectImage = styled(Card.Img)`
  width: 3rem;
`

export const ListItemWrapper = styled.ul`
  padding: 0;
`
